<p-panel>
  <div class="row">
    <app-reactive-form-builder
      #formbuilder
      (stableValueChanges)="stableValueChanges($event)"
      (goBack)="goBack()"
      (afterSend)="undefined"
      [form]="form.formFields"
      [serverUrl]="''"
      [id]="reactiveFormRecordId"
      [request]="request"
      [getRequest]="crmApiService.CRM.GET">
    </app-reactive-form-builder>
  </div>
</p-panel>